// import vConsole from 'vconsole';
import Vue from 'vue';
Vue.prototype.flag = false;
export default {
  // watch:{
  //   '$route'(){
  //     if(!this.ThirdObj.from){
  //       this.ThirdObj.from = this.$route.meta ? this.$route.meta.from : 0;
  //     }
  //   }
  // },
  created(){
    
    if(this.$route && this.$route.meta.from &&  this.$route.meta.from !=1){
      // if(!Vue.prototype.flag){
        // new vConsole();
        // Vue.prototype.flag = true;
      // } 
      
    }
    if((!this.ThirdObj.from || !this.ThirdObj.userUniId) && this.$route) {
      this.getPageFrom();
    }
    if(!Vue.prototype.flag){
      Vue.prototype.flag = true;
      this.getBrowser();
    }
  },
  mounted(){ 
    if(this.routerMixins){
     
      // 根据网络连接情况更新在线状态
      // console.log(location)
      // console.log(this.$route)
      window.addEventListener('offline',  this.updateIndicator);
    }
  },
  methods: {
    getPageFrom() {  // 获取 授权的code 值
      this.ThirdObj.from = this.$route.meta ? this.$route.meta.from : 0;
      this.ThirdObj.code = this.getSearchData('code');
      this.ThirdObj.userUniId = this.getSearchData('userUniId');
      this.ThirdObj.appid = this.getSearchData('appid');
    },
    getSearchData(name){
      let reg = new RegExp(name + "=([^&$#]*)(&|$|#)", "i"); 
      var r = window.location.href.match(reg); 
      if (r != null) {return unescape(r[1]);}
      return null;
    },
    updateIndicator() {
      if(this.$router && this.$route.name !== 'offline'){
        this.$router.push('/offline');
      }
    },
    getBrowser(){
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
         this.ThirdObj.isIOS = true;
      } else if (/(Android)/i.test(navigator.userAgent)|| /(Adr)/i.test(navigator.userAgent)) {
        this.ThirdObj.isAndroid = true;
      } else {
        this.ThirdObj.isPC = true;
      };
    }
  }
}